export function dualViewLangsTab(side: 'left' | 'right') {
    const cacheKey = `isOpenedSelfTransInDual-${side}`;

    function getCacheValue() {
        return sessionStorage.getItem(cacheKey) === 'true';
    }

    function setCacheValue(value: boolean) {
        sessionStorage.setItem(cacheKey, value ? 'true': 'false');
    }

    return {
        getCacheValue,
        setCacheValue,
    }
}
